import type { BasketResponse } from "@onestore/api/basket"
import type { HTTP } from "@onestore/onestore-store-common"
import { HTTP_STATUS } from "@onestore/onestore-store-common/http"
import type { Draft } from "immer"
import { produce } from "immer"
import type { QuickCheckoutSummaryActions } from "~/store/quick-checkout/actions"
import { QuickCheckoutActionType } from "~/store/quick-checkout/constants"

export type QuickCheckoutState = {
  readonly basket: BasketResponse
  readonly requestState: HTTP.Status
}

export const initialState: QuickCheckoutState = {
  requestState: HTTP_STATUS.NONE,
  basket: {
    token: null,
    items: [],
    status: "none",
    total_net_price: 0,
    total_vat_value: 0,
    handling_net_value: 0,
    payment_methods: [],
    payment_method: null,
    terms: [],
    items_count: 0,
    plans_usage_over_limit: [],
    savings: 0,
    order_id: null,
    domains: [],
    domain_upsell: [],
    pmails: [],
    order_number: "",
    account_type: null,
    promo_code: "",
    needs_parameters: false,
  },
}

export default function reducer(
  state: QuickCheckoutState = initialState,
  action: QuickCheckoutSummaryActions
): QuickCheckoutState {
  return produce<QuickCheckoutState, QuickCheckoutState>(
    state,
    (nextState: Draft<QuickCheckoutState>): void => {
      switch (action.type) {
        case QuickCheckoutActionType.SUMMARY_PENDING:
          nextState.requestState = HTTP_STATUS.CONTINUE

          return
        case QuickCheckoutActionType.SUMMARY_SUCCESS:
          nextState.basket = action.basket
          nextState.requestState = HTTP_STATUS.OK

          return
        case QuickCheckoutActionType.SUMMARY_ERROR:
          nextState.requestState = action.response_status_code

          return
      }
    }
  )
}
